import { FormatRegistry } from "@sinclair/typebox";

/** TypeBox validates `format` only for registered formats; register the ones our contracts use. */
const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
if (!FormatRegistry.Has("date-time")) {
  FormatRegistry.Set("date-time", (v) => ISO_DATE_TIME.test(v) && !Number.isNaN(Date.parse(v)));
}
if (!FormatRegistry.Has("uuid")) {
  FormatRegistry.Set("uuid", (v) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v));
}
